export default __webpack_public_path__ + "static/media/the_tower.ed1b7fee.png";